import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiFetch } from "../../utils";

// Async thunk to fetch all users (once)
export const fetchFeatureToggles = createAsyncThunk(
    "admin/fetchAllUsers",
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiFetch("api/haki/featuretoggle");
            return await response.json();
        } catch (error) {
            return rejectWithValue([]);
        }
    }
);

const ToggleSlice = createSlice({
    name: "Toggle",
    initialState: {
        DEPLOYMENT_CONFIG_SELECTION: false,
        PUBLIC_CLIENTINFO_DOWNLOAD: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFeatureToggles.fulfilled, (state, action) => {
                state.DEPLOYMENT_CONFIG_SELECTION = action.payload.find(t => t.name == "DEPLOYMENT_CONFIG_SELECTION")?.value;
                state.PUBLIC_CLIENTINFO_DOWNLOAD = action.payload.find(t => t.name == "PUBLIC_CLIENTINFO_DOWNLOAD")?.value;
            })
    },
});

export default ToggleSlice.reducer;
